import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerContent,
} from "@heroui/react";
import { UserPlus } from "lucide-react";
import { GetSubscription } from "@/server-types";
import {
  getLocalizedName,
  getLocalizedValue,
  getTranslatedTimeframe,
} from "@/utils";
import { Trans } from "@lingui/react/macro";
import { useNavigate } from "react-router";

const SubscriptionVariationModal = ({
  variation,
  subscription,
  isOpen,
  onOpenChange,
  onClose,
}: {
  variation: GetSubscription["response"]["subscriptionVariations"][0];
  subscription: GetSubscription["response"];
  isOpen: boolean;
  onOpenChange: () => void;
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <Drawer isOpen={isOpen} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <h1 className="text-xl font-medium">
            {getLocalizedValue(subscription.nameLocalized)} -{" "}
            {getLocalizedValue(variation.nameLocalized)}
          </h1>
        </DrawerHeader>
        <DrawerBody className="flex flex-col gap-1 text-xs">
          <p className="mb-4">
            {getLocalizedValue(subscription.descriptionLocalized)}
          </p>

          <p>
            <Trans>Trajanje</Trans>:{" "}
            <span className="font-medium">
              {variation.durationValue}{" "}
              {getTranslatedTimeframe(variation.durationUnit)}
            </span>
          </p>

          <div className="flex flex-row gap-2">
            <p>
              <Trans>Storitve</Trans>
            </p>
            <div className="flex w-full flex-col font-medium">
              {subscription.subscriptionServices.map((service) => (
                <div
                  key={service.serviceId}
                  className="flex w-full flex-row items-center justify-between gap-2"
                >
                  <p>• {getLocalizedName(service.service.nameLocalized)}</p>
                  <p className="font-normal text-gray-500">
                    {service.limitations.map((limitation) => (
                      <span
                        className="font-normal text-gray-500"
                        key={limitation.id}
                      >
                        {limitation.limitAmount} /{" "}
                        {getTranslatedTimeframe(limitation.timeframe)}
                      </span>
                    ))}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-end">
            <p className="text-xl font-semibold">
              {variation.priceCentsFormatted}
            </p>
          </div>

          <Button
            color="primary"
            radius="sm"
            startContent={<UserPlus className="h-4 w-4" />}
            onPress={() => navigate("/dashboard/customers/")}
          >
            <Trans>Dodeli stranko</Trans>
          </Button>
        </DrawerBody>
        <DrawerFooter className="flex w-full flex-row justify-end">
          <Button variant="light" onPress={onClose}>
            <Trans>Zapri</Trans>
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default SubscriptionVariationModal;
